//redux
import { useSelector } from "react-redux"

// *************************************************************
//     Misc

// const initialContext = {
// loadingDocs: false,
// catalogoDocs: [],
// catalogo_xniveleducativo: [],
// docs_xpersona: [],
// error: "",

export function useDocumentosNotification() {
  return useSelector(state => state.Documentos.context.notificacion)
}

export function useDocumentosUploadDoc() {
  return useSelector(state => state.Documentos.context.uploadDoc)
}

export function useDocumentosLoadingDocs() {
  return useSelector(state => state.Documentos.context.loadingDocs)
}

export function useDocumentosCatalogoDocs() {
  return useSelector(state => state.Documentos.context.catalogoDocs)
}

export function useDocumentosCatalogo_xniveleducativo() {
  return useSelector(state => state.Documentos.context.catalogo_xniveleducativo)
}

export function useDocumentosDocs_xpersona() {
  return useSelector(state => state.Documentos.context.docs_xpersona)
}

export function useDocumentosError() {
  return useSelector(state => state.Documentos.context.error)
}

export function useDocumentosDocumento() {
  return useSelector(state => state.Documentos.context.documento)
}

export function useDocumentosId_Relacion_Persona_Documento() {
  return useSelector(
    state => state.Documentos.context.id_Relacion_Persona_Documento
  )
}

export function useDocumentosRefreshListaDocs() {
  return useSelector(state => state.Documentos.context.refreshListaDocs)
}
